'use client';
import { Button } from '@mui/material';
import { useTranslations } from 'next-intl';

import { useCommentsSectionContext } from './CommentsSectionContext';

export default function LeaveCommentButton() {
  const { comments } = useCommentsSectionContext();
  const translate = useTranslations();

  if (!comments.length || comments.length < 5) {
    return null;
  }

  return (
    <a href="#comments-section">
      <Button>{translate('comments-button')}</Button>
    </a>
  );
}
